import React, { PureComponent } from 'react';

import style from './index.scss';
import styles from './result.css';
import './resultDetail.css';
import download from 'images/preferential/download.png';

import { Link } from 'react-router-dom';

export default class ResultDetail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {
        return (
            <div className="main_search_detail">
                <div className="center" style={{ marginTop: '0' }}>
                    <div className="center_search">
                        <div className="center_position_info"></div>
                        <span style={{ color: '#18388c', fontSize: '24px' }}>1退役军人互联网应用培训_</span><span style={{ lineHeight: '24px', color: '#18388c' }}>结果查询</span>
                    </div>
                    <div className="application_info">
                        <div className="application_info_title"><span style={{ marginLeft: '10px' }}>申请人基本信息</span></div>
                    </div>
                    <div className="margin-b15">
                        <div className="application_basic_info">
                            <div className="application_basic_left">
                                <span style={{ marginRight: '16px' }}>申请人姓名：</span>
                            </div>
                            <span>张三</span>
                        </div>

                        <div className="application_basic_info">
                            <div className="application_basic_left">
                                <span style={{ marginRight: '16px' }}>证件号码：</span>
                            </div>
                            <span>429005189876509087</span>
                        </div>

                        <div className="application_basic_info">
                            <div className="application_basic_left">
                                <span style={{ marginRight: '16px' }}>性别：</span>
                            </div>
                            <span>男</span>
                        </div>

                        <div className="application_basic_info">
                            <div className="application_basic_left">
                                <span style={{ marginRight: '16px' }}>联系电话：</span>
                            </div>
                            <span>13978925645</span>
                        </div>
                        
                        <div className="application_basic_info">
                            <div className="application_basic_left">
                                <span style={{ marginRight: '16px' }}>联系地址：</span>
                            </div>
                            <span>海南省三亚市西乡塘区大学东路100号</span>
                        </div>
                    </div>

                    <div className="application_info">
                        <div className="application_info_title"><span style={{ marginLeft: '10px' }}>申办事项信息</span></div>
                    </div>

                    <div className="application_info_table">
                        <table width='100%' border='1' cellPadding='0' cellSpacing='0'>
                            <tbody>
                                <tr>
                                    <td className="info_td_left">事项名称</td>
                                    <td className="info_td_center">海棠区办事处退役军人互联网应用培训</td>
                                    <td className="info_td_left">事项类型</td>
                                    <td className="info_td_right">教育培训服务</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">面向对象</td>
                                    <td className="info_td_center">伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人等</td>
                                    <td className="info_td_left">办件业务系统</td>
                                    <td className="info_td_right">互联网+退役军人服务云平台</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">实施主体</td>
                                    <td className="info_td_center">海南三亚市海棠区退役军人事务处</td>
                                    <td className="info_td_left">实施主体性质</td>
                                    <td className="info_td_right">事业单位</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">法定办结时限</td>
                                    <td className="info_td_center">20（工作日）</td>
                                    <td className="info_td_left">承诺办结时限</td>
                                    <td className="info_td_right">15（工作日）</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">办件类型</td>
                                    <td className="info_td_center">承诺件</td>
                                    <td className="info_td_left">办理形式</td>
                                    <td className="info_td_right">窗口办理/网上办理</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">费用</td>
                                    <td className="info_td_center">免费</td>
                                    <td className="info_td_left">中介服务</td>
                                    <td className="info_td_right">无</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">培训机构</td>
                                    <td className="info_td_center">三亚退役军人培训中心</td>
                                    <td className="info_td_left">申请金额（元）</td>
                                    <td className="info_td_right">6000</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">培训时间</td>
                                    <td className="info_td_center">2020-03-19</td>
                                    <td className="info_td_left">培训地点</td>
                                    <td className="info_td_right">海南三亚市海棠区星湖1000号发展大厦1001</td>
                                </tr>
                                <tr>
                                    <td className="info_td_left">办件状态</td>
                                    <td className="info_td_center" style={{ color: '#18388c' }}>已通过</td>
                                    <td className="info_td_left">办件结果</td>
                                    <td className="info_td_right" style={{ color: '#18388c' }}>办件结果下载</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="application_info">
                        <div className="application_info_title"><span style={{ marginLeft: '10px' }}>申办事项材料清单</span></div>
                    </div>

                    <div className="application_info_table_next">
                        <table width='100%' border='1' cellPadding='0' cellSpacing='0' style={{ fontSize: '14px' }}>
                            <tr className="signss" style={{ background: 'rgba(247,247,247,.5)' }}>
                                <td className="list_left_td">序号</td>
                                <td className="list_left_name">材料名称</td>
                                <td className="list_left_orgin">原件</td>
                                <td className="list_left_copy">复印件</td>
                                <td className="list_left_upload">文件下载</td>
                            </tr>
                            <tr>
                                <td className="list_left_td">1</td>
                                <td className="list_left_name">培训补贴申请表</td>
                                <td className="list_left_orgin">1</td>
                                <td className="list_left_copy">1</td>
                                <td className="list_left_upload"><a href="https://codeload.github.com/douban/douban-client/legacy.zip/master" style={{ color: '#333' }} download="示例文件"><img src={download} style={{ marginRight: '5px' }} />文件</a></td>
                            </tr>
                            <tr>
                                <td className="list_left_td">2</td>
                                <td className="list_left_name">退役军人证</td>
                                <td className="list_left_orgin">0</td>
                                <td className="list_left_copy">1</td>
                                <td className="list_left_upload"><a href="https://codeload.github.com/douban/douban-client/legacy.zip/master" style={{ color: '#333' }} download="示例文件"><img src={download} style={{ marginRight: '5px' }} />文件</a></td>
                            </tr>
                            <tr>
                                <td className="list_left_td">3</td>
                                <td className="list_left_name">身份证</td>
                                <td className="list_left_orgin">0</td>
                                <td className="list_left_copy">1</td>
                                <td className="list_left_upload"><a href="https://codeload.github.com/douban/douban-client/legacy.zip/master" style={{ color: '#333' }} download="示例文件"><img src={download} style={{ marginRight: '5px' }} />文件</a></td>
                            </tr>
                        </table>

                    </div>
                </div>
                {/* 当前位置 */}

            </div>
        )
    }
}